import { connect } from 'react-redux';
import { getAboutHiddenReason } from 'profile/containers/edit';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import About from 'profile/components/about';

const mapStateToProps = (state) => {
  return {
    ...mapProfileToProps(state),
    hidden: !!getAboutHiddenReason(state.profile.view)
  };
}

export default connect(mapStateToProps)(About);



// WEBPACK FOOTER //
// ./profile/containers/about.js